export { default } from './StoresList'
